import { HttpUrlEncodingCodec } from '@angular/common/http';

// https://www.moritz-benzenhoefer.com/2018/01/angular-http-requests-use-square-brackets-in-httpparams-as-parameter-key-name/
export class SquareBracketsHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
  encodeKey(k: string): string {
    return super.encodeKey(k).replace(new RegExp('%5B', 'g'), '[').replace(new RegExp('%5D', 'g'), ']');
  }
}
